<select
  [ngModel]="selectedAnalyzerIndex"
  (ngModelChange)="itemSelected($event)"
  data-testId="doctor-select"
>
  <option
    *ngFor="let option of options, let i = index"
    [value]="i"
    [attr.data-testId]="option.testId"
  >
    {{ option.text }}
    <span *ngIf="shouldMarkOptionAsCurrentlySelected(option)">
      ({{ "assignDoctorSelectorLabelCurrent" | localize }})
    </span>
  </option>
</select>
